<mat-form-field appearance="outline" class="full-width">
  <mat-label>{{ label }}</mat-label>
  <mat-select [value]="value" [placeholder]="placeholder" [disabled]="disabled" [formControl]="control"
    (selectionChange)="onSelectionChange($event)">
    <mat-option *ngFor="let option of options" [value]="option.value">
      {{ option.label }}
    </mat-option>
  </mat-select>
  <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>
</mat-form-field>